import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingsServicedeskRovoServiceAgentRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskRovoServiceAgentRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import ServiceDeskRovoServiceAgent, {
	LazyProjectSettingsServiceDeskRovoServiceAgent,
} from './ui/service-desk-rovo-service-agent/ServicedeskRovoServiceAgentComponent.tsx';

export const projectSettingsServicedeskRovoServiceAgentRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingsServicedeskRovoServiceAgentRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-rovo-service-agent-settings',
		component: ServiceDeskRovoServiceAgent,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskRovoServiceAgent],
		perfMetricKey: 'jsm-rovo-service-agent-settings',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskRovoServiceAgentRouteEntry.tsx',
				whichExportToUse: 'projectSettingsServicedeskRovoServiceAgentRouteEntry',
			},

			enabled: true,
		},
	}));
